// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1MwCo","rootCenter":"LoadMoreObserver_rootCenter__1QppY","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__qy2FO"};